import { COPY_STRINGS } from "../../../../constants/translatedCopy";
import { PROGRESS_STATES, SPEECH_VOLUME_CHECK_STATES } from "../StudentVolumeChecksConstants";
import { amiraGestures } from '../../../Coach/GesturedSpeech'

export default async function handleTeacherModeSpeech({speechProps, currentProgressState, settings, spotHook, goToNextState, setCurrentSpeechVolumeCheckState, acceptedAtKindOfLoudVolume, toggleReaderContainer, showMicIcon, setShowTeacherTroubleshootScreen}){

    if (currentProgressState === PROGRESS_STATES.INITIAL) {
        spotHook.disappear()
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.INTRODUCTION_SCREEN_1) {
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.INTRODUCTION_SCREEN_2) {
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_TRANSITION_ON_SCREEN) {
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_ON_SCREEN) {
        spotHook.goSleep()
        showMicIcon();
        goToNextState()
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_ON_SCREEN_2) {
        await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_volume_welcome_one })
        setCurrentSpeechVolumeCheckState(SPEECH_VOLUME_CHECK_STATES.WAITING_FOR_INITIAL_SPEECH)
    }
    if (currentProgressState === PROGRESS_STATES.SPOT_WOKE_UP) {
        await spotHook.wakeUpFromSleep()
        speechProps.playDance({
            gesture: amiraGestures.ThumbsUp
        })

        setShowTeacherTroubleshootScreen(true)

        if (acceptedAtKindOfLoudVolume) {
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_volume_success_but_loud_one })
        } else {
            await speechProps.speakWithPromise({ textToSpeak: COPY_STRINGS.student_checks.teacher_mode_volume_success_one })
        }
    }
}